import { useRouter } from 'next/router';
import React from 'react';
import { connect } from 'react-redux';

import Error from '@/pages/_error';
import ListPageStates from '@/src/shared/components/ListPage/ListPageStates';
import useListSearch from '@/src/shared/hooks/useListSearch';
import states from '@/utils/states';

const isBrowser = typeof window !== 'undefined';

const searchOptions = {
  pubCode: 81,
  yearsBack: 2,
};

const EnactedLawBulletin = props => {
  const router = useRouter();
  const { statecode, isLoggedIn } = props;
  const _statecode = statecode || router.query.slug || 0;
  const [loading, results] = useListSearch(searchOptions, _statecode);

  if (isBrowser && !isLoggedIn) return <Error status={401} />;

  return (
    <ListPageStates
      title="Enacted Law Bulletin"
      heroContent={<p>Documents from the last 2 years</p>}
      results={results}
      truncateResultSummary
      searchOptions={searchOptions}
      statecode={_statecode}
      loading={loading}
      titlePrefix=""
      routeBase="/compliance/regulatory-changes/enacted-law-bulletin"
    />
  );
};

export async function getStaticPaths() {
  return {
    paths: states.map(s => ({ params: { slug: s.StateCode } })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  return {
    props: {
      statecode: params.slug || 0,
    },
  };
}

export default connect(
  state => {
    const { auth } = state;
    const { isLoggedIn } = auth;
    return { isLoggedIn };
  },
  null
)(EnactedLawBulletin);
